import api from '@/api'

// const Pinyin = require('pinyin/lib/pinyin');

// // 解压拼音库。
// // @param {Object} dict_combo, 压缩的拼音库。
// // @param {Object} 解压的拼音库。
// /* eslint-disable */
// function buildPinyinCache(dict_combo){
//   let hans;
//   const uncomboed = {};

//   for (const py in dict_combo){
//     hans = dict_combo[py];
//     for(let i = 0, han, l = hans.length; i < l; i++){
//       han = hans.charCodeAt(i);
//       if(!uncomboed.hasOwnProperty(han)){
//         uncomboed[han] = py;
//       }else{
//         uncomboed[han] += "," + py;
//       }
//     }
//   }

//   return uncomboed;
// }

// const PINYIN_DICT = buildPinyinCache(require('pinyin/data/dict-zi'));

// const pinyin = new Pinyin(PINYIN_DICT);
/* eslint-disable global-require, arrow-body-style  */

// initial state
const state = {
  teachers: [],
  research: [],
  title: [],
  talent: [],
  talentTeacher: [],
  postdoctoral: [],
  cultivateTeacher: [],
  postgraduateOptions: [
    {
      name: '硕士导师',
      name_e: 'Master',
      type: 'master'
    },
    {
      name: '博士导师',
      name_e: 'Doctoral',
      type: 'doctor'
    }
  ],
  nameWords: [
    'A', 'B', 'C', 'D', 'E',
    'F', 'G', 'H', 'I', 'J',
    'K', 'L', 'M', 'N', 'O',
    'P', 'Q', 'R', 'S', 'T',
    'U', 'V', 'W', 'X', 'Y',
    'Z'
  ],
  talentNameWords: [],
  localTeacher: {
    name: '杨小康',
    image: {
      thumbnail_url: '/static/%E6%9D%A8%E5%B0%8F%E5%BA%B7-min.png',
    },
    introduction: [
      {
        content: [
          '1994年在厦门大学获理学学士学位',
          '1997年在中科院上海技术物理所获工学硕士学位',
          '2000年在上海交通大学获工学博士学位'
        ],
        content_en: [
          '1994年在厦门大学获理学学士学位',
          '1997年在中科院上海技术物理所获工学硕士学位',
          '2000年在上海交通大学获工学博士学位'
        ]
      },
      {
        content: [
          '2000-2004年，在新加坡信息与通信研究院工作',
          '2004年11月至今，上海交通大学电子工程系任教',
          '2007-2008年为德国弗莱堡大学计算机系洪堡学者'
        ],
        content_en: [
          '2000-2004年，在新加坡信息与通信研究院工作',
          '2004年11月至今，上海交通大学电子工程系任教',
          '2007-2008年为德国弗莱堡大学计算机系洪堡学者'
        ],
      },
      {
        content: [
          '1.深度学习与视频大数据分析',
          '2.虚拟现实与增强现实',
          '3.视频处理与质量评价'
        ],
        content_en: [
          '1.深度学习与视频大数据分析',
          '2.虚拟现实与增强现实',
          '3.视频处理与质量评价'
        ],
      },
      {
        content: [
          '[1]J. C. Yan, M. Cho, H. Y. Zha, Xiaokang Yang, S. Chu: Multi-Graph Matching via Affinity Optimization with Graduated Consistency Regularization.  IEEE Transactions on Pattern Analysis and Machine Intelligence, accepted in 2015.',
          '[2]J. Zhu, T.F. Wu, S.-C. Zhu, Xiaokang Yang,W.J. Zhang: A Reconfigurable Tangram Model for Scene Representation and Categorization. IEEE Transactions on Image Processing, 25(1):150-166,2015.',
          '[3]L.Y. Ma, Xiaokang Yang, D.C. Tao: Person Re-identification over Camera Networks using Multi-task Distance Metric Learning. IEEE Transactions on Image Processing, 23(8): 3656-3670, 2014.',
          '[4]G. T. Zhai, X. L. Wu, Xiaokang Yang, W. S. Lin: A Psychovisual Quality Metric in Free Energy Principle. IEEE Transactions on Image Processing, 21(1):41-52, 2012.',
          '[5]Z. W. Wang, E. Kuruoglu, Xiaokang Yang, Y. Xu, Thomas S. Huang: Time Varying Dynamic Bayesian Network for Non-Stationary Events Modeling and Online Inference, IEEE Transactions on Signal Processing, 59(4): 1553-1568, Apr. 2011.'
        ],
        content_en: [
          '[1]J. C. Yan, M. Cho, H. Y. Zha, Xiaokang Yang, S. Chu: Multi-Graph Matching via Affinity Optimization with Graduated Consistency Regularization.  IEEE Transactions on Pattern Analysis and Machine Intelligence, accepted in 2015.',
          '[2]J. Zhu, T.F. Wu, S.-C. Zhu, Xiaokang Yang,W.J. Zhang: A Reconfigurable Tangram Model for Scene Representation and Categorization. IEEE Transactions on Image Processing, 25(1):150-166,2015.',
          '[3]L.Y. Ma, Xiaokang Yang, D.C. Tao: Person Re-identification over Camera Networks using Multi-task Distance Metric Learning. IEEE Transactions on Image Processing, 23(8): 3656-3670, 2014.',
          '[4]G. T. Zhai, X. L. Wu, Xiaokang Yang, W. S. Lin: A Psychovisual Quality Metric in Free Energy Principle. IEEE Transactions on Image Processing, 21(1):41-52, 2012.',
          '[5]Z. W. Wang, E. Kuruoglu, Xiaokang Yang, Y. Xu, Thomas S. Huang: Time Varying Dynamic Bayesian Network for Non-Stationary Events Modeling and Online Inference, IEEE Transactions on Signal Processing, 59(4): 1553-1568, Apr. 2011.'
        ],
      },
      {
        content: [
          '1. EE346: “数字图像处理,” 春季'
        ],
        content_en: [
          '1. EE346: “数字图像处理,” 春季'
        ],
      },
      {
        content: [],
        content_en: [],
      },
      {
        content: [
          '1.IEEE Transactions on Multimedia编委',
          '2.IEEE Signal Processing Letters编委'
        ],
        content_en: [
          '1.IEEE Transactions on Multimedia编委',
          '2.IEEE Signal Processing Letters编委'
        ],
      },
      {
        content: [
          '2016年，国家“万人计划”科技创新领军人才',
          '2016年，IEEE ICME2016最佳学生论文奖',
          '2015年，教育部长江学者特聘教授',
          '2015年，国家科技进步二等（第二完成人）',
          '2014年，中国学位与研究生教育学会研究生教育成果二等奖（第一完成人）',
          '2014年，上海市研究生优秀成果奖（硕士学位）',
          '2014年，上海市优秀学术带头人',
          '2013年，科技部创新人才推进计划--中青年科技创新领军人才',
          '2012年，第六届上海青年科技英才',
          '2012年，上海高校特聘教授（东方学者）跟踪计划',
          '2011年，上海市科技进步一等奖（第一完成人）',
          '2010年，国家杰出青年科学基金',
          '2008年，（首届）上海高校特聘教授（东方学者）',
          '2006年，（首届）微软青年教授奖',
          '2006年， 教育部新世纪优秀人才支持计划',
          '2005年， 上海市青年科技启明星计划',
          '2004年，新加坡陈嘉庚基金发明奖',
          '2003年，国际光学工程师协会视频通讯和图象处理青年科学家奖',
          '2003年，新加坡信息与通信研究院最佳论文奖'
        ],
        content_en: [
          '2016年，国家“万人计划”科技创新领军人才',
          '2016年，IEEE ICME2016最佳学生论文奖',
          '2015年，教育部长江学者特聘教授',
          '2015年，国家科技进步二等（第二完成人）',
          '2014年，中国学位与研究生教育学会研究生教育成果二等奖（第一完成人）',
          '2014年，上海市研究生优秀成果奖（硕士学位）',
          '2014年，上海市优秀学术带头人',
          '2013年，科技部创新人才推进计划--中青年科技创新领军人才',
          '2012年，第六届上海青年科技英才',
          '2012年，上海高校特聘教授（东方学者）跟踪计划',
          '2011年，上海市科技进步一等奖（第一完成人）',
          '2010年，国家杰出青年科学基金',
          '2008年，（首届）上海高校特聘教授（东方学者）',
          '2006年，（首届）微软青年教授奖',
          '2006年， 教育部新世纪优秀人才支持计划',
          '2005年， 上海市青年科技启明星计划',
          '2004年，新加坡陈嘉庚基金发明奖',
          '2003年，国际光学工程师协会视频通讯和图象处理青年科学家奖',
          '2003年，新加坡信息与通信研究院最佳论文奖'
        ],
      }
    ]
  },
  allTeachers: [],
  teacherTitle: {
    en: '教育部长江学者特聘教授',
    cn: '教育部长江学者特聘教授',
  },

  teachersDetail: {},

  teacherT: {
    en: [
      'Cheung Kong Scholars Chair Professor',
      'Executive Vice Dean, Artificial Intelligence Institute, Shanghai Jiao Tong University',
      'Deputy Director, Institute of Image Communication and Information Processing, Shanghai Jiao Tong University'
    ],
    cn: [
      '张香港学者讲座教授',
      '上海交通大学人工智能学院执行副院长',
      '上海交通大学图像通信与信息处理研究所副所长'
    ]
  },

  introductionTitle: [
    {
      img: require('@/assets/images/Educational-background.svg'),
      title_en: 'Educational background',
      title: '教育背景',
    },
    {
      img: require('@/assets/images/WorkExperience.svg'),
      title_en: 'Work experience',
      title: '工作经历',
    },
    {
      img: require('@/assets/images/PatentsAndSoftwareCopyright.svg'),
      title_en: 'Patents and software copyright',
      title: '专利与软件著作权'
    },
    {
      img: require('@/assets/images/Representative.svg'),
      title_en: 'Representative papers and monograph',
      title: '代表性论文专著',
    },
    {
      img: require('@/assets/images/AcademicReport.svg'),
      title_en: 'Academic report',
      title: '学术报告',
    },
    {
      img: require('@/assets/images/TeachingWork.svg'),
      title_en: 'Teaching work',
      title: '科研成果',
    },
    {
      img: require('@/assets/images/TeachingWork.svg'),
      title_en: 'Teaching work',
      title: '教学工作',
    },
    {
      img: require('@/assets/images/Part-Time.svg'),
      title_en: 'Part-time Academic Job',
      title: '学术兼职',
    },
    {
      img: require('@/assets/images/HonorAndReward.svg'),
      title_en: 'Honor and reward',
      title: '荣誉奖励',
    },
    {
      img: require('@/assets/images/ResearchDirection.svg'),
      title_en: 'Research direction',
      title: '研究方向',
    },
  ],

  contactsPassage: {
    img: require('@/assets/images/Contact.svg'),
    title_en: 'Contact',
    title: '联系方式',
  },

  contacts: [
    {
      title: '通讯地址',
      title_en: 'Address',
      content_en: '5-415 SEIEE, No. 800 Dongchuan Road, Shanghai',
      content: '上海市东川路800号电信群楼 5-415'
    },
    {
      title: '办公电话',
      title_en: 'Office Tel',
      content: '+86 21 34204463',
      content_en: '+86 21 34204463',
    },
    {
      title: '电子邮箱',
      title_en: 'Email',
      content: 'xkyang@sjtu.edu.cn',
      content_en: 'xkyang@sjtu.edu.cn'
    }
  ],
}

// getters
const getters = {
}

// mutation types
const FIND_TEACHERS = 'FIND_TEACHER'
const FIND_RESEARCH = 'FIND_RESEARCH'
const FIND_TITLE = 'FIND_TITLE'
const FIND_TALENT = 'FIND_TALENT'
const FIND_TALENT_TEACHERS = 'FIND_TALENT_TEACHERS'
const FIND_POSTDOCTORAL = 'FIND_POSTDOCTORAL'
const FIND_CULTIVATE_TEACHERS = 'FIND_CULTIVATE_TEACHERS'
const FIND_ALL_TEACHER = 'FIND_ALL_TEACHER'
const SETUP_TEACHER = 'SETUP_TEACHER'
const SETUP_TEACHER_SHOW = 'SETUP_TEACHER_SHOW'
const SETUP_TALENT_TEACHER_SHOW = 'SETUP_TALENT_TEACHER_SHOW'

// actions
const actions = {
  async findTeachers({ commit }, { data }) {
    const result = await api.teacher.findTeachers(data)
    commit(FIND_TEACHERS, { teachers: result })
  },

  async findAllTeachers({ commit }, { data }) {
    const result = await api.teacher.findTeachers(data)
    commit(FIND_ALL_TEACHER, { teachers: result.teachers })
  },

  async findTalentTeachers({ commit }, { data }) {
    const result = await api.teacher.findTalentTeachers(data)
    commit(FIND_TALENT_TEACHERS, { teachers: result })
  },

  async findPostdoctoral({ commit }, { data }) {
    const result = await api.teacher.findPostdoctoral(data)
    commit(FIND_POSTDOCTORAL, { postdoctoral: result })
  },

  async findCultiveTeacher({ commit }, { data }) {
    const result = await api.teacher.findCultiveTeacher(data)
    commit(FIND_CULTIVATE_TEACHERS, { teachers: result })
  },

  async findResearch({ commit }) {
    const result = await api.teacher.findResearch()
    commit(FIND_RESEARCH, { research: result })
  },

  async findTitle({ commit }) {
    const result = await api.teacher.findTitle()
    commit(FIND_TITLE, { title: result })
  },

  async findTalent({ commit }) {
    const result = await api.teacher.findTalent()
    commit(FIND_TALENT, { talent: result })
  },
}

// mutations
const mutations = {
  [FIND_ALL_TEACHER](state, { teachers }) {
    state.allTeachers = teachers
  },

  [SETUP_TEACHER](state, { teacher }) {
    if (!teacher.introduction) {
      state.teachersDetail = teacher
      return
    }
    const introduction = teacher.introduction
    const introductionEn = teacher.introduction_en

    state.contacts[0].content = introduction[1].content
    state.contacts[0].content_en = introductionEn[1].content
    state.contacts[1].content = introduction[2].content
    state.contacts[1].content_en = introductionEn[2].content
    state.contacts[2].content = introduction[3].content
    state.contacts[2].content_en = introductionEn[3].content

    state.teacherTitle.cn = introduction[0].content
    state.teacherTitle.en = introductionEn[0].content

    introduction.splice(3, 1)
    introduction.splice(2, 1)
    introduction.splice(1, 1)
    introduction.splice(0, 1)

    introductionEn.splice(3, 1)
    introductionEn.splice(2, 1)
    introductionEn.splice(1, 1)
    introductionEn.splice(0, 1)

    teacher.introduction = introduction
    teacher.introduction_en = introductionEn

    state.teachersDetail = teacher
  },

  [FIND_CULTIVATE_TEACHERS](state, { teachers }) {
    state.cultivateTeacher = teachers.teachers.map((teacher) => {
      teacher.image = teacher.image || {}
      return teacher
    })
  },

  [FIND_POSTDOCTORAL](state, { postdoctoral }) {
    state.postdoctoral = postdoctoral.teachers
  },

  [SETUP_TEACHER_SHOW](state, { word }) {
    if (word === 'All') {
      state.teachers.forEach((teacher) => {
        teacher.show = true
      })
      return
    }

    state.teachers.forEach((teacher) => {
      if (teacher.surname !== word && word !== '') {
        teacher.show = false
      } else {
        teacher.show = true
      }
    })
  },

  [FIND_TEACHERS](state, { teachers }) {
    const words = []
    state.teachers = teachers.teachers
    state.teachers.forEach((teacher) => {
      teacher.show = true
      // const surname = pinyin(teacher.name) && pinyin(teacher.name)[0][0]
      const word = teacher.firstSpell
      teacher.surname = word
      teacher.image = teacher.image || {}

      if (words.indexOf(word) === -1) {
        words.push(word)
      }
    })

    words.sort((a, b) => {
      return a.localeCompare(b)
    })

    state.nameWords = words
  },

  [SETUP_TALENT_TEACHER_SHOW](state, { word }) {
    if (word === 'All') {
      state.talentTeacher.forEach((teacher) => {
        teacher.show = true
      })
      return
    }

    state.talentTeacher.forEach((teacher) => {
      if (teacher.surname !== word && word !== '') {
        teacher.show = false
      } else {
        teacher.show = true
      }
    })
  },

  [FIND_TALENT_TEACHERS](state, { teachers }) {
    const words = []
    state.talentTeacher = teachers.teachers
    state.talentTeacher.forEach((teacher) => {
      teacher.show = true
      // const surname = pinyin(teacher.name) && pinyin(teacher.name)[0][0]
      const word = teacher.firstSpell
      teacher.surname = word
      teacher.image = teacher.image || {}

      if (words.indexOf(word) === -1) {
        words.push(word)
      }
    })

    words.sort((a, b) => {
      return a.localeCompare(b)
    })

    state.talentNameWords = words
  },

  [FIND_RESEARCH](state, { research }) {
    const allResearch = {
      name: '全部',
      name_en: 'All',
      id: 0,
    }
    state.research = research.teacherResearchs
    state.research.splice(0, 0, allResearch)
  },

  [FIND_TITLE](state, { title }) {
    const allResearch = {
      name: '全部',
      name_en: 'All',
      id: 0,
    }
    state.title = title.teacherTitles
    state.title.splice(0, 0, allResearch)
  },

  [FIND_TALENT](state, { talent }) {
    const allResearch = {
      name: '全部',
      name_en: 'All',
      id: 0,
    }
    state.talent = talent.teacherTalents
    state.talent.splice(0, 0, allResearch)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/teacher.js